module.exports = __webpack_public_path__ + "img/mastercard-pill.9e573b99.svg";